import React from "react";
import { HiExclamationCircle } from "react-icons/hi";

const CustomInput = ({
    label,
    name,
    register,
    required,
    type = "text",
    placeholder,
    icon: Icon,
    errors,
    disabled,
    validation = {},
    onKeyDown,
    maxLength,
  }) => {
    return (
      <div className="mb-4">
        
        <div className="relative">
          
          <input
            {...register(name, {
              required: required && `${label} is required`,
              ...validation,
            })}
            name={name}
            disabled={disabled}
            type={type}
            placeholder={placeholder}
            maxLength={maxLength}
            onKeyDown={onKeyDown}
            className={`border px-2 h-[40px] w-full rounded-[10px] focus:outline-none ${
                errors[name] ? "border-red-500" : "border-slate-200 focus:border-primary"
              } pr-10`}
          
          />
         
        </div>
        {errors[name] && (
          <div className="text-red-500 text-[11px] mt-1">{errors[name].message}</div>
        )}
      </div>
    );
  };
  

export default CustomInput;
